import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBox,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('Total', (theme) => ({
  root: {
    background: theme.palette.primary.main,
    '& .FD-MuiTypography-root': {
      color: theme.palette.common.white,
    },
  },
}));

export function Total({
  label, value, ...rest
}) {
  const classes = useStyles();
  return (
    <div {...rest} className={classes.root}>
      <FDBox paddingX={4} paddingY={2}>
        <FDStack flexGrow={1} justifyContent="space-between" spacing={3}>
          <FDTitleText value={label} size="lg" />
          <FDTitleText value={value} size="lg" />
        </FDStack>
      </FDBox>
    </div>
  );
}

Total.defaultProps = {
};

Total.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};
